'use client';

import * as React from 'react';

import cookie from 'cookie';

import { useSendCollectorEventMutation } from '@/modules/collector/hooks/use-send-collector-event-mutation';

import { getUserAgentBrowserDetails, getUserAgentOperatingSystemDetails } from '@/shared/modules/user-agent';

import { ANALYTIC_DEFAULT_CLUSTER, ANALYTIC_DEFAULT_NETWORK, ANALYTIC_EVENT_SOURCE } from '../constants';
import type { CollectorEventData } from '../types';

/**
 * @useClient
 */
export const useRaiseCollectorEvent = () => {
  const { mutate: fetchSendCollectorEvent } = useSendCollectorEventMutation();

  const raiseCollectorEvent = React.useCallback(
    (
      event: { eventName: string; eventAction: string; eventCategory: string; eventLabel: string },
      params: CollectorEventData = {},
    ) => {
      const userAgentBrowserDetails = getUserAgentBrowserDetails();
      const userAgentOperatingSystemDetails = getUserAgentOperatingSystemDetails();

      const cookies = cookie.parse(document.cookie);

      const data: CollectorEventData = {
        b: userAgentBrowserDetails.name,
        bv: userAgentBrowserDetails.version,
        cl: ANALYTIC_DEFAULT_CLUSTER,
        en: event.eventName,
        lp: cookies['lp'] ? decodeURIComponent(cookies['lp']) : null,
        net: ANALYTIC_DEFAULT_NETWORK,
        os: userAgentOperatingSystemDetails.name,
        osv: userAgentOperatingSystemDetails.version,
        ref: document.referrer,
        src: ANALYTIC_EVENT_SOURCE,
        urlp: cookies['q'] ? decodeURIComponent(cookies['q']) : null,
        ea: event.eventAction,
        ec: event.eventCategory,
        el: event.eventLabel,
        gaid: cookies['or_id.v1'] ? decodeURIComponent(cookies['or_id.v1']) : null,
        ...params,
      };

      fetchSendCollectorEvent(data, {
        onSuccess: () => console.info('%c[collector]%c Event sent', 'color: #bada55', '', data),
      });
    },
    [fetchSendCollectorEvent],
  );

  return {
    raiseCollectorEvent,
  };
};
